/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GCPSubnetSchema
 */
export interface GCPSubnetSchema {
    /**
     * 
     * @type {string}
     * @memberof GCPSubnetSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GCPSubnetSchema
     */
    cidr: string;
    /**
     * 
     * @type {string}
     * @memberof GCPSubnetSchema
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof GCPSubnetSchema
     */
    id: string;
}

/**
 * Check if a given object implements the GCPSubnetSchema interface.
 */
export function instanceOfGCPSubnetSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "cidr" in value;
    isInstance = isInstance && "link" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function GCPSubnetSchemaFromJSON(json: any): GCPSubnetSchema {
    return GCPSubnetSchemaFromJSONTyped(json, false);
}

export function GCPSubnetSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): GCPSubnetSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'cidr': json['cidr'],
        'link': json['link'],
        'id': json['id'],
    };
}

export function GCPSubnetSchemaToJSON(value?: GCPSubnetSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'cidr': value.cidr,
        'link': value.link,
        'id': value.id,
    };
}

